var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgWindows = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 160 160"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0078d6",
  d: "M0 22.993 65 14v63.007H0m72.993-64.014L160 0v76H72.993M0 84h65v63.007l-65-9.014M72.993 84H160v76l-86-12.007"
})));

export default SvgWindows;